export default "__VITE_ASSET__2717af1c__"